export default __webpack_public_path__ + "static/media/shoshi.f9b0d456.jpg";